import { Activity } from "lucide-react";

/** Cortina de carregamento: esconde a montagem do terminal até tudo estar pronto. */
export const TerminalLoader = ({ visible }) => (
  <div
    data-testid="terminal-loader"
    className={`absolute inset-0 z-40 flex flex-col items-center justify-center gap-4 bg-[#050810] transition-opacity duration-500 ${
      visible ? "opacity-100" : "pointer-events-none opacity-0"
    }`}
  >
    <div className="flex items-center gap-3">
      <span className="flex h-10 w-10 items-center justify-center rounded-md bg-[#132038]">
        <Activity className="h-5 w-5 animate-pulse text-[#5B9CFF]" />
      </span>
      <span className="font-heading text-lg tracking-[0.3em] text-[#E6EDF7]">MERIDIAN</span>
    </div>
    <div className="h-1 w-48 overflow-hidden rounded-full bg-[#141A26]">
      <div className="h-full w-1/3 animate-[loaderSlide_1.1s_ease-in-out_infinite] rounded-full bg-[#5B9CFF]" />
    </div>
    <p className="text-xs uppercase tracking-[0.3em] text-[#5B6579]">A preparar o terminal</p>
  </div>
);
